let state = {
    REGOP_Catalogos_002TiposDependencias: {},
    REGOP_Catalogos_003TiposEnvio: {}
}

let getters = {
    Get_REGOP_Catalogos_002TiposDependencias: state => {
        return state.REGOP_Catalogos_002TiposDependencias;
    },
    Get_REGOP_Catalogos_003TiposEnvio: state => {
        return state.REGOP_Catalogos_003TiposEnvio;
    }
}

let mutations = {
    M_REGOP_Catalogos_002TiposDependencias(state, data) {
        state.REGOP_Catalogos_002TiposDependencias[data.llave] = data.valor;
    },
    M_REGOP_Catalogos_003TiposEnvio(state, data) {
        state.REGOP_Catalogos_003TiposEnvio[data.llave] = data.valor;
    }
}

let actions = {
    A_REGOP_Catalogos_002TiposDependencias: ({ commit }, data) => {
        commit('M_REGOP_Catalogos_002TiposDependencias', data)
    },
    A_REGOP_Catalogos_003TiposEnvio: ({ commit }, data) => {
        commit('M_REGOP_Catalogos_003TiposEnvio', data)
    }
}

const REGOP = {
    State: state,
    Getters: getters,
    Mutations: mutations,
    Actions: actions
}

export default REGOP;



// WEBPACK FOOTER //
// ./src/store/REGOP.js